import { render, staticRenderFns } from "./Grade3RebuildIndividualContacts.vue?vue&type=template&id=68b0fa48&scoped=true"
import script from "./Grade3RebuildIndividualContacts.vue?vue&type=script&lang=js"
export * from "./Grade3RebuildIndividualContacts.vue?vue&type=script&lang=js"
import style0 from "./Grade3RebuildIndividualContacts.vue?vue&type=style&index=0&id=68b0fa48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b0fa48",
  null
  
)

export default component.exports